"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOccupiedMeasureBucketsLocalIdentifiers = exports.getBulletChartSeries = exports.isComparativeSeries = exports.isTargetSeries = exports.isPrimarySeries = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2021 GoodData Corporation
var common_1 = require("../_util/common");
var commonConfiguration_1 = require("../_chartCreators/commonConfiguration");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var SUPPORTED_MEASURE_BUCKETS = [
    sdk_ui_1.BucketNames.MEASURES,
    sdk_ui_1.BucketNames.SECONDARY_MEASURES,
    sdk_ui_1.BucketNames.TERTIARY_MEASURES,
];
var PRIMARY_VS_COMPARATIVE_MEASURE_HEIGHT_RATIO = 0.75;
var isComparativeMeasurePresent = function (bucketLocalIdentifiers) {
    return bucketLocalIdentifiers.includes(sdk_ui_1.BucketNames.TERTIARY_MEASURES);
};
var isTargetMeasurePresent = function (bucketLocalIdentifiers) {
    return bucketLocalIdentifiers.includes(sdk_ui_1.BucketNames.SECONDARY_MEASURES);
};
var getValue = function (value, isTarget) {
    return isTarget
        ? {
            target: value === null ? 0 : value,
            y: 0,
        }
        : {
            y: value,
        };
};
var getSeriesItemData = function (seriesItem, measureGroup, seriesIndex, measureBucketsLocalIdentifiers) {
    return seriesItem.map(function (pointValue) {
        var value = common_1.parseValue(pointValue);
        var isTarget = exports.isTargetSeries(seriesIndex, measureBucketsLocalIdentifiers);
        var nullValueProps = isTarget && value === null ? { isNullTarget: true, className: "hidden-empty-series" } : {};
        return tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, nullValueProps), getValue(value, isTarget)), { format: common_1.unwrap(measureGroup.items[seriesIndex]).format, marker: {
                enabled: pointValue !== null,
            }, name: common_1.unwrap(measureGroup.items[seriesIndex]).name });
    });
};
var getPrimarySeriesMaxPointWidth = function (onlyPrimaryMeasure) {
    if (!onlyPrimaryMeasure) {
        return commonConfiguration_1.MAX_POINT_WIDTH * PRIMARY_VS_COMPARATIVE_MEASURE_HEIGHT_RATIO;
    }
    return commonConfiguration_1.MAX_POINT_WIDTH;
};
var getPrimarySeries = function (seriesItemConfig, onlyPrimaryMeasure) { return (tslib_1.__assign(tslib_1.__assign({}, seriesItemConfig), { pointPadding: onlyPrimaryMeasure ? 0.1 : 0.2, maxPointWidth: getPrimarySeriesMaxPointWidth(onlyPrimaryMeasure), zIndex: 1, bulletChartMeasureType: "primary" })); };
var getTargetSeries = function (seriesItemConfig) { return (tslib_1.__assign(tslib_1.__assign({}, seriesItemConfig), { type: "bullet", pointPadding: 0, targetOptions: {
        width: "100%",
    }, zIndex: 2, bulletChartMeasureType: "target" })); };
var getComparativeSeries = function (seriesItemConfig) { return (tslib_1.__assign(tslib_1.__assign({}, seriesItemConfig), { pointPadding: 0, zIndex: 0, bulletChartMeasureType: "comparative" })); };
exports.isPrimarySeries = function (seriesIndex, bucketsLocalIdentifiers) {
    return seriesIndex === bucketsLocalIdentifiers.indexOf(sdk_ui_1.BucketNames.MEASURES);
};
exports.isTargetSeries = function (seriesIndex, bucketsLocalIdentifiers) {
    return seriesIndex === bucketsLocalIdentifiers.indexOf(sdk_ui_1.BucketNames.SECONDARY_MEASURES);
};
exports.isComparativeSeries = function (seriesIndex, bucketsLocalIdentifiers) {
    return seriesIndex === bucketsLocalIdentifiers.indexOf(sdk_ui_1.BucketNames.TERTIARY_MEASURES);
};
var getSeries = function (seriesIndex, seriesItemConfig, measureBucketsLocalIdentifiers) {
    if (exports.isTargetSeries(seriesIndex, measureBucketsLocalIdentifiers)) {
        return getTargetSeries(seriesItemConfig);
    }
    else if (exports.isComparativeSeries(seriesIndex, measureBucketsLocalIdentifiers)) {
        return getComparativeSeries(seriesItemConfig);
    }
    var onlyPrimaryMeasure = !isComparativeMeasurePresent(measureBucketsLocalIdentifiers) &&
        !isTargetMeasurePresent(measureBucketsLocalIdentifiers);
    return getPrimarySeries(seriesItemConfig, onlyPrimaryMeasure);
};
function getBulletChartSeries(dv, measureGroup, colorStrategy) {
    var occupiedMeasureBucketsLocalIdentifiers = getOccupiedMeasureBucketsLocalIdentifiers(dv);
    var executionResultData = dv.rawData().twoDimData();
    return executionResultData.map(function (seriesItem, seriesIndex) {
        var seriesItemData = getSeriesItemData(seriesItem, measureGroup, seriesIndex, occupiedMeasureBucketsLocalIdentifiers);
        var seriesItemConfig = {
            legendIndex: seriesIndex,
            data: seriesItemData,
            name: measureGroup.items[seriesIndex].measureHeaderItem.name,
            color: colorStrategy.getColorByIndex(seriesIndex),
            seriesIndex: seriesIndex,
        };
        return getSeries(seriesIndex, seriesItemConfig, occupiedMeasureBucketsLocalIdentifiers);
    });
}
exports.getBulletChartSeries = getBulletChartSeries;
function getOccupiedMeasureBucketsLocalIdentifiers(dv) {
    var buckets = dv.def().buckets();
    var executionResultData = dv.rawData().twoDimData();
    var availableMeasureBucketsLocalIdentifiers = SUPPORTED_MEASURE_BUCKETS;
    var notEmptyMeasureBucketsLocalIdentifiers = buckets
        .filter(function (b) {
        return !sdk_model_1.bucketIsEmpty(b) && availableMeasureBucketsLocalIdentifiers.indexOf(b.localIdentifier) >= 0;
    })
        .map(function (b) { return b.localIdentifier; });
    return !isEmpty_1.default(notEmptyMeasureBucketsLocalIdentifiers)
        ? notEmptyMeasureBucketsLocalIdentifiers
        : availableMeasureBucketsLocalIdentifiers.slice(0, executionResultData.length);
}
exports.getOccupiedMeasureBucketsLocalIdentifiers = getOccupiedMeasureBucketsLocalIdentifiers;
//# sourceMappingURL=bulletChartSeries.js.map